import { render, staticRenderFns } from "./Comments.vue?vue&type=template&id=e81bfa0e&scoped=true&"
import script from "./Comments.vue?vue&type=script&lang=js&"
export * from "./Comments.vue?vue&type=script&lang=js&"
import style0 from "./Comments.vue?vue&type=style&index=0&id=e81bfa0e&lang=scss&scoped=true&"
import style1 from "./Comments.vue?vue&type=style&index=1&id=e81bfa0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81bfa0e",
  null
  
)

export default component.exports